import { render, staticRenderFns } from "./NoColumnSettings.vue?vue&type=template&id=6ed19d62&scoped=true&"
import script from "./NoColumnSettings.vue?vue&type=script&lang=js&"
export * from "./NoColumnSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed19d62",
  null
  
)

export default component.exports